import React, { Suspense } from "react";
import { Canvas, useFrame } from "@react-three/fiber";

import { useLoader } from "@react-three/fiber";
import { PCDLoader } from "three/examples/jsm/loaders/PCDLoader";
import { usePCD } from "../hooks";
import { AdditiveBlending, MultiplyBlending, NoBlending, NormalBlending, Points } from "three";
import { Config, Metadata } from "../types";

const loader = new PCDLoader();

export default function Region({
  metadata,
  config,
  setConfig,
  color,
  disabled = false,
}: {
  metadata: Metadata;
  config: Config;
  setConfig: React.Dispatch<React.SetStateAction<Config>>;
  color: string;
  disabled?: boolean;
}) {
  //   // This reference gives us direct access to the THREE.Mesh object
  //   const ref = React.useRef() as any;
  //   // Hold state for hovered and clicked events
  const [hovered, hover] = React.useState(false);
  //   const [clicked, click] = React.useState(false);
  //   // Subscribe this component to the render-loop, rotate the mesh every frame
  //   useFrame((state, delta) => (ref.current.rotation.x += 0.01));
  //   // Return the view, these are regular Threejs elements expressed in JSX
  // const a = useFBX
  //   try {
  //     const pcd = useLoader(PCDLoader, "/brain_region_pcds/region_1.pcd");
  //     console.log("pcd123", pcd);
  //   } catch (e) {
  //     (async () => {
  //       console.log("err,", await e);
  //     })();
  //   }

  const pcd = usePCD(`/brain_region_pcds/region_${metadata.id}.pcd`);
  //
  //   pcd.material.size =10;
  if (
    (metadata.isRightHemisphere && !config.showRightHemisphere) ||
    (!metadata.isRightHemisphere && !config.showLeftHemisphere)
  ) {
    disabled = true;
  } else if (config.selectedResource && metadata.resourceId !== config.selectedResource) {
    disabled = true;
  } else if (config.selectedRegion && metadata.id !== config.selectedRegion) {
    disabled = true;
  }
  // else if (config.filtexIdx.length > 0) {
  //   disabled = true;

  //   if (config.colormap === "cortex") {
  //     if ((metadata.isCortex && config.filtexIdx.includes(1)) || (!metadata.isCortex && config.filtexIdx.includes(2))) {
  //       disabled = false;
  //     }
  //   }

  //   if (config.colormap === "resource") {
  //     if (metadata.resourceId && config.filtexIdx.includes(metadata.resourceId)) {
  //       disabled = false;
  //     }
  //   }

  //   if (config.colormap === "id") {
  //     if (config.filtexIdx.includes(metadata.id) || config.filtexIdx.includes(metadata.id - 51)) {
  //       disabled = false;
  //     }
  //   }
  // }
  return (
    <primitive
      object={pcd}
      className="region"
      position={[-97, -97, -97]}
      // onPointerOver={(event: any) => {
      // console.log("hover");
      // const newIntersections = event.intersections.map((i: any) => i.object.name);
      // console.log(event.intersections[0].object.name);
      // setConfig({ ...config, intersectionHoverIdsRegion: newIntersections });
      // }}
      onDoubleClick={(event: any) => {
        // console.log("aa");
        if (!config.selectedResource && metadata.isCortex && !disabled) {
          for (let i = 0; i < event.intersections.length; i++) {
            if (!event.intersections[i].object.transparent) {
              console.log("setting confiog");
              setConfig({ ...config, selectedResource: metadata.resourceId });
              break;
            }
          }
          // console.log(event.intersections[0].object);
          // console.log(event.intersections[0].object.name);
          // console.log(event.object.name);
          // }
        }
      }}
      name={metadata.id}
      // onPointerOver={(event: any) => {
      // if (!event.object.name) {
      //   console.log("aa");
      // }
      // console.log(event.object.name);
      // }}
    >
      {/* map: texture,
        blending: THREE.AdditiveBlending,
        transparent: true,
        depthTest: false,
        sizeAttenuation: true, */}

      {/* {disabled ? ( */}
      <pointsMaterial
        size={disabled ? config.brainPointSize / 1000 : 1.3}
        color={disabled ? "#000000" : color}
        transparent={!disabled}
        opacity={disabled ? config.disabledPointOpacity / 1000 : 1}
        needsUpdate
        blending={disabled ? NormalBlending : NormalBlending}
        depthTest={!disabled}
        // sizeAttenuation={true}
      />
      {/* ) : (
        <pointsMaterial size={1.3} color={color} transparent opacity={1} needsUpdate />
      )} */}
      {/* transparent opacity={config.disabledPointOpacity / 1000}  */}
      {/*  */}
    </primitive>
    // <primitive object={pcd} scale={10} />
    // <points>
    //   <bufferGeometry args={[pcd.geometry.attributes.position]} />
    //
    // </points>
    // <Suspense fallback={null}>{/*  */}</Suspense>
    // <mesh
    //   ref={ref}
    //   scale={clicked ? 1.5 : 1}
    //   onClick={(event) => click(!clicked)}
    //
    //   onPointerOut={(event) => hover(false)}
    // >
    //   <boxGeometry args={[3, 5, 3]} />
    //   <meshStandardMaterial color={hovered ? "hotpink" : "orange"} />
    // </mesh>
  );
}
